<template>
    <div class="pagination-area">
        <ul>
            <li v-if="null != pageObj && pageObj.hasPreviousPage">
                <button class="pageButton" @click="previousPage"><font-awesome-icon icon="fa-solid fa-angle-left" /></button>
            </li>

            <li v-for="(v, i) in pageObj.navigatepageNums" :key="i">
                <button class="active" v-if="pageObj.pageNum == v"><span>{{v}}</span></button>

                <button class="pageButton" v-if="pageObj.pageNum != v" @click="goPage(v)"><span>{{v}}</span></button>
            </li>

            <li v-if="null != pageObj && pageObj.hasNextPage">
                <button class="pageButton" @click="nextPage"><font-awesome-icon icon="fa-solid fa-angle-right" /></button>
            </li>
        </ul>
    </div>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons'

    library.add(faAngleRight, faAngleLeft)

    const props = defineProps(['pageObj'])
    const emits = defineEmits(['goPage'])

    function goPage(num) {
        emits("goPage", num)
    }

    function previousPage() {
        goPage(Number(props.pageObj.pageNum) - 1)
    }

    function nextPage() {
        goPage(Number(props.pageObj.pageNum) + 1)
    }

</script>

<style scoped>
    .pagination-area {
        /*background: rgba(0, 0, 0, 0) none repeat scroll 0 0;*/
        border-top: 1px solid #e5e5e5;
        margin: 22px 0 0;
        /*padding-top: 20px;*/
        text-align: center;
        /*display: inline-block;*/
        width: 100%;
        user-select: none;
    }

    .pagination-area ul {
        margin-bottom: 0;
        padding-left: 0;
    }
    .pagination-area ul li {
        background: #f5f5f5;
        color: #393939;
        display: inline-block;
        font-size: 12px;
        font-weight: 700;
        height: 30px;
        line-height: 30px;
        margin: 0 0 5px 5px;
        width: 30px;
    }
    .pagination-area ul li .active {
        border: 1px solid #e5e5e5;
        color: #363636;
        display: block;
        font-size: 12px;
        font-weight: 700;
        height: 30px;
        width: 30px;
        text-decoration: none;
        transition: all .4s ease-out .2s;
        border-radius: 3px;
        cursor: pointer;
    }
    .pagination-area ul li .active:hover {
        background: #e83f33;
        border: 1px solid #e83f33;
        color: #fff;
    }
    .pagination-area ul li .active {
        background: #e83f33;
        border: 1px solid #e83f33;
        color: #fff;
        transition: all .4s ease-out .2s;
    }

    .pageButton {
        width: 30px;
        background-color: #F5F5F5;
        border: 0;
        cursor: pointer;
        color: #393939;
        font-weight: 700;
    }
</style>